<template>
  <nav class="nav" :class="{ 'is-Active': showMenu }">
    <h1 class="logo">
      <button class="menuToggle" :class="{ 'is-Active': showMenu }" @click="toggleMenu()">
        <icon name="bars"></icon>
      </button>

      <span>Motyro</span>
    </h1>
    <ul class="nav__List">
      <template>
        <navItem v-for="item in navItems" :item="item" :key="item.id"></navItem>
      </template>

      <li class="nav__Item" v-if="isAdmin || isSuperAdmin">
        <router-link class="nav__ItemLink" :to="{ name: 'Active users' }">
          <icon class="nav__ItemIcon" name="users"></icon>{{ $store.getters.getStringTranslation('users') }}
          <span v-if="(isAdmin || isAdmin) && pending && pending.length > 0" class="notificationBubble">{{
            pending.length
          }}</span>
        </router-link>
      </li>

      <li class="nav__Item" v-if="isSuperAdmin">
        <router-link class="nav__ItemLink" to="/organisations">
          <icon class="nav__ItemIcon" name="sitemap"></icon>{{ $store.getters.getStringTranslation('organisations') }}
          <span v-if="isAdmin && pendingOrgs && pendingOrgs.length > 0" class="notificationBubble">{{
            pendingOrgs.length
          }}</span>
        </router-link>
      </li>

      <li class="nav__Item" v-if="isSuperAdmin">
        <router-link class="nav__ItemLink" to="/websites">
          <icon class="nav__ItemIcon" name="globe"></icon>{{ $store.getters.getStringTranslation('websites') }}
        </router-link>
      </li>

      <li class="nav__Item nav__Item--Lang">
        <span class="nav__ItemLink">
          <icon class="nav__ItemIcon" name="language"></icon>
          <ul class="langNav">
            <li
              v-for="lang in $store.state.ui.languages"
              :key="lang.id"
              @click="$store.dispatch('setUILang', lang)"
              :class="{ 'langNav__Item--Active': $store.state.ui.lang === lang }"
            >
              {{ lang }}
            </li>
          </ul>
        </span>
      </li>

      <li class="nav__Item">
        <button class="nav__ItemLink" @click="logOut()">
          <icon class="nav__ItemIcon" name="power-off"></icon>{{ $store.getters.getStringTranslation('logout') }}
        </button>
      </li>
    </ul>

    <div class="user" v-if="org.full_name">
      <div class="user__SiteSelect">
        <select class="formSelect" v-model="currentApiKey" v-if="websites.length > 1">
          <option :value="[]">{{ $store.getters.getStringTranslation('chooseWebsite') }}</option>
          <option v-for="website in websites" :value="[website.api_key]" :key="website.id">
            {{ website.url }}
          </option>
        </select>
      </div>
      <router-link to="/settings/account" class="user__Info">
        <icon class="user__InfoChevron" name="chevron-circle-right" />
        <span class="user__InfoIcon" v-if="org.full_name">{{ firstLetter(org.full_name) }}</span>
        <span class="user__InfoName">{{ user.name }}</span>
        <span class="user__InfoEmail" v-if="org.full_name">{{ org.full_name }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import NavItem from '@/components/nav/NavItem.vue'

export default {
  name: 'PopNav',
  components: {
    NavItem,
  },
  data() {
    return {
      showMenu: false,
      navItems: [
        { label: 'Dashboard', id: 'dashboard', icon: 'desktop', route: '/' },
        {
          label: 'Submissions',
          id: 'submissions',
          icon: 'arrow-alt-circle-down',
          route: '/submissions',
        },
        { label: 'Pages', id: 'pages', icon: 'file', route: '/pages' },
        { label: 'Posts', id: 'blog', icon: 'pencil', route: '/blog' },
        { label: 'Campaigns', id: 'campaigns', icon: 'star', route: '/campaigns' },
        { label: 'Projects', id: 'projects', icon: 'flag', route: '/projects' },
        { label: 'Events', id: 'events', icon: 'calendar', route: '/events' },
        {
          label: 'Library',
          icon: 'columns',
          children: [
            { label: 'External articles', id: 'article', icon: 'newspaper', route: '/news' },
            { label: 'Publications', id: 'publications', icon: 'file-alt', route: '/publications' },
            {
              label: 'Digital publications',
              id: 'digital_publications',
              icon: 'print',
              route: '/digital-publications',
            },
            {
              label: 'Clauses',
              id: 'clause',
              icon: 'gavel',
              route: '/clauses',
            },
            { label: 'Multimedia', id: 'multimedia', icon: 'file-video', route: '/multimedia' },
            { label: 'Case studies', id: 'case_studies', icon: 'file', route: '/case-studies' },
          ],
        },
        { label: 'Quizes', id: 'quiz', icon: 'question', route: '/quizes' },
        { label: 'Uploads', id: 'uploads', icon: 'upload', route: '/uploads' },
        { label: 'Tag management', id: 'tags', icon: 'tags', route: '/tags' },
      ],
    }
  },
  computed: {
    websites() {
      return this.$store.state.accounts.org.websites
    },
    currentApiKey: {
      set(item) {
        this.$store.dispatch('getCurrentWebsite', { item })
        this.$cookie.set('current_website', item)
        this.$router.push({
          query: { ...this.$route.query, api_key: [item.api_key] },
        })
      },
      get() {
        return this.$store.state.websites.current
      },
    },
    user() {
      return this.$store.state.accounts.user
    },
    org() {
      return this.$store.state.accounts.org
    },
    pending() {
      return this.$store.state.accounts.users.pending
    },
    pendingOrgs() {
      let orgs = []
      if (this.$store.state.accounts.orgs.length > 0) {
        orgs = this.$store.state.accounts.orgs.filter((obj) => {
          return obj.status === 'pending'
        })
      }
      return orgs
    },
    isAdmin() {
      if (this.user.is_admin || this.user.is_org_admin) return true
      return false
    },
    isSuperAdmin() {
      if (this.user.is_admin) return true
      return false
    },
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    firstLetter(string) {
      return string.charAt(0)
    },
    logOut() {
      localStorage.removeItem('token')
      this.$router.push({ path: '/login' })
    },
  },
  created() {
    const currentWebsiteCookie = this.$cookie.get('current_website')
    if (this.$store.state.websites.current.length > 0) {
      this.currentApiKey = this.$store.state.websites.current
    } else if (currentWebsiteCookie) {
      this.currentApiKey = [currentWebsiteCookie]
    } else if (this.$route.query.search) {
      const search = JSON.parse(this.$route.query.search)
      this.currentApiKey = search.api_keys
    }

    if (this.$cookie.get('menu_open')) {
      this.showMenu = true
    }
  },
  watch: {
    showMenu() {
      if (this.showMenu === true) {
        this.$cookie.set('menu_open')
      } else {
        this.$cookie.delete('menu_open')
      }
    },
  },
}
</script>
